import { Attachment } from '../../../types';
import { AttachmentQueue } from '../AttachmentQueue';
import { AttachmentTableCTA } from '../AttachmentCTA/AttachmentTableCTA';

interface AttachmentsSectionProps {
  disabled: boolean;
  attachments: Attachment[];
  onAdd: (files: File[]) => void;
  onRemove: (attachmentId: string) => void;
  onCancel: (attachmentId: string) => void;
  onRetry: (attachmentId: string) => void;
}

/** The staged files of the active tab with their upload state, and the controls to add, remove, cancel or retry one. */
export function AttachmentsSection({
  disabled,
  attachments,
  onAdd,
  onRemove,
  onCancel,
  onRetry
}: AttachmentsSectionProps) {
  return (
    <div
      className="flex w-full flex-col gap-2"
      data-cy="order-request-attachments">
      {attachments.length > 0 && (
        <AttachmentQueue
          queuedAttachments={attachments}
          cancelUpload={onCancel}
          retryUpload={onRetry}
          removeAttachment={disabled ? undefined : onRemove}
          showProgressPercentage
        />
      )}
      {!disabled && (
        <AttachmentTableCTA
          addAttachments={onAdd}
          label="Add Attachments"
        />
      )}
    </div>
  );
}
